import Account from './views/Account.svelte';
import Accounts from './views/Accounts.svelte';
import AdminAlertsReport from './views/AdminAlertsReport.svelte';

const routes = {
  '/': Accounts,
  '/accounts': Accounts,
  '/account': Account,
  '/account/:account_id': Account,
  '/account/new': Account,
  '/reports/alert-count-report': AdminAlertsReport,
  '*': Accounts
};

export default routes;